import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { loader_image } from "../_components/Imagepath";
import {MaterialReactTable} from 'material-react-table';
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import {

  MenuItem,
} from '@mui/material';
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const Products = () => {
  const [menu, setMenu] = useState(false);
  // const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  const [dataa, setDataa] = useState([]);

  
  useEffect(() => {
        setPermission(FindModuleById(5)); 
console.log(permission);

        axios
      .post(`/products/listing`,{}, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setDataa(response.data.data.products);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

 
 
  
  
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

 
 // ✅ Functional component for Details Cell
 const DetailsCell = ({  row }) => {
   return <a href={`/products-groupby-name/${row.original.id}`}>{row.original.name}</a>;
 };
 // ✅ Define PropTypes for DetailsCell
 DetailsCell.propTypes = {
   renderedCellValue: PropTypes.string.isRequired,
   row: PropTypes.shape({
     original: PropTypes.shape({
       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
       name: PropTypes.string.isRequired, // ✅ Add this line

     }).isRequired,
   }).isRequired,
 };
  const columns2 =
  [

    {
      header: 'Name',
      accessorFn: (row) => `${row.name}`,
      Cell: DetailsCell, // ✅ Assigning function directly (No inline)
    },
    {
      header: 'Product Type',
      accessorFn: (row) => `${(row.type)?row.type.title:""} `,
    },
 
  {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   
   ];

    

    const editItem = (item)=>{
    window.location.href = "/products-edit/"+item;
  }
 const deleteItem = (item) => {
      Swal.fire({
        title: 'Do you really want to delete this record?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'DELETE'
      }).then((result) => {
        if (result.isConfirmed) {
          axios.get(`/products/delete/${item}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                console.log(response);
                if (response.data.code === 200) {
                  Swal.fire(
                    'Deleted!',
                    'Your Record has been deleted.',
                    'success'
                  );
                  setTimeout(() => {
                    window.location.href = "/products";
                  }, 500);
                }
              })
              .catch((error) => {
                console.log(error);
              });
        }
      });
    }
const downloadPDF = async (product) => {
  if (product.file) {
    AWS.config.update({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: AWS_DEFAULT_REGION,
      signatureVersion: 'v4',
    });

    const s3 = new AWS.S3();
    const params = {
      Bucket: AWS_BUCKET,
      Key: product.file,
      Expires: 60 // expires in 60 seconds
    };

    // 1. Get the signed URL
    const signedUrl = s3.getSignedUrl('getObject', params);

    // 2. Trigger download using an <a> tag
    const link = document.createElement('a');
    link.href = signedUrl;
    link.setAttribute('download', product.file.split('/').pop()); // e.g., "invoice.pdf"
    link.setAttribute('target', '_blank'); // optional: open in new tab if needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    alert("PDF file not found for this product.");
  }
};



  const FichedePalletePDF = async (product) => {

    $("#loader-image1").removeClass('loader-hide');
    $("#loader-image1").addClass('loader-show');
    axios.get(`/products/pdf/${product.id}`, {
      responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
      }).then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          const productName = product?.name?.trim() || 'product';
          const productType = product?.type?.name?.trim() || 'type';
          const fileName = `${productName} ${productType}.pdf`;
          link.download = fileName;
          link.click();
          $("#loader-image1").addClass('loader-hide');
            $("#loader-image1").removeClass('loader-show');
      })
      .catch(error => {
          console.error('Error downloading PDF:', error);
      });

  };

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />  
      {/* <ToastContainer /> */}

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Products</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Products</li>
                </ul>
              </div>
              <div className="col-auto">
              {permission && permission.add === 1 && (
                   <Link to="/products-add" className="btn btn-primary me-1">
                   <i className="fas fa-plus"></i>
                 </Link>
                )} 
               
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {permission && permission.list === 1 && (
                  <div className="table-responsive">
                      <MaterialReactTable columns={columns2} data={dataa} 
                        enableColumnOrdering
                        enablePinning
                        enableRowActions
                        renderRowActionMenuItems={({ row }) => [
                          permission?.update === 1 && (
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>
                          ),
                           permission?.list === 1 && (
                              <MenuItem key="view" onClick={() => FichedePalletePDF(row.original)}>
                              Download <img  id={`loader-image1`} className="loader-image loader-hide" src={loader_image}/> 
                            </MenuItem>
                            ),
                           permission?.list === 1 && (
                              <MenuItem key="view" onClick={() => downloadPDF(row.original)}>
                              Download PDF <img  id={`loader-image1`} className="loader-image loader-hide" src={loader_image}/> 
                            </MenuItem>
                            ),
                          permission?.delete === 1 && (
                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              Delete
                            </MenuItem>
                          ),
                        ]}
                    />                     
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Products;
